(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[328],{

/***/ 4615:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notice",
      function () {
        return __webpack_require__(5180);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5578);
/* harmony import */ var _svg_Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4555);


const IconCancel = (param)=>/*#__PURE__*/ {
    let { ...rest } = param;
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_svg_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        ...rest,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
            d: "M19.0711 5.07107L12 12.1421M12 12.1421L4.92893 19.2132M12 12.1421L19.0711 19.2132M12 12.1421L4.92893 5.07107",
            stroke: "#9090A0",
            strokeWidth: "1.5",
            strokeLinecap: "round"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconCancel);


/***/ }),

/***/ 4149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5578);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(102);
/* harmony import */ var _svg_Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4555);



const DIRECTION_DEGREE = {
    right: 0,
    left: 180
};
const IconChevron24pxRightLeft = (param)=>{
    let { direction ="right" , ...rest } = param;
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(StyledSvg, {
        degree: DIRECTION_DEGREE[direction],
        ...rest,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
            d: "M10 19L16.6464 12.3536C16.8417 12.1583 16.8417 11.8417 16.6464 11.6464L10 5",
            stroke: "#626273",
            strokeWidth: "1.5",
            strokeLinecap: "round"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (IconChevron24pxRightLeft);
const StyledSvg = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_svg_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "e1osa9c50"
})("transform:rotate(", (param)=>{
    let { degree  } = param;
    return degree;
}, "deg);");


/***/ }),

/***/ 54:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5578);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7978);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(102);
/* harmony import */ var _icon_IconCancel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8164);
/* harmony import */ var _icon_IconChevron24pxRightLeft__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4149);





const AppBar = (param)=>{
    let { backButtonType ="chevron" , title , rightElement , onClickBackButton  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    const handleBackButton = ()=>{
        if (onClickBackButton) {
            onClickBackButton();
            return;
        }
        router.back();
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(BackButton, {
                onClick: handleBackButton,
                children: backButtonType === "chevron" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_icon_IconChevron24pxRightLeft__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    direction: "left"
                }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_icon_IconCancel__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
            }),
            title && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Title, {
                children: title
            }),
            rightElement && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(RightElementWrapper, {
                children: rightElement
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AppBar);
const APP_BAR_HEIGHT = "48px";
const Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("section", {
    target: "e1lb8s0i0"
})({
    position: "sticky",
    left: 0,
    top: "0",
    width: "100%",
    height: APP_BAR_HEIGHT,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "900"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.white
    };
});
const BackButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("button", {
    target: "e1lb8s0i1"
})({
    all: "unset",
    position: "absolute",
    // NOTE: - wapper padding + design padding
    left: "calc(-20px + 8px)",
    cursor: "pointer",
    width: "3rem",
    height: "3rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const Title = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("h2", {
    target: "e1lb8s0i2"
})((param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.subTitle,
        color: theme.colors.gray6
    };
});
const RightElementWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e1lb8s0i3"
})({
    position: "absolute",
    // NOTE: - wapper padding + design padding
    right: "calc(-20px + 8px)"
});


/***/ }),

/***/ 4555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5578);

const Svg = (param)=>{
    let { size , width , height , color , isUsingFill =false , children , viewBox ="0 0 24 24" , ...rest } = param;
    var ref, ref1;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: (ref = width !== null && width !== void 0 ? width : size) !== null && ref !== void 0 ? ref : 24,
        height: (ref1 = height !== null && height !== void 0 ? height : size) !== null && ref1 !== void 0 ? ref1 : 24,
        fill: isUsingFill ? color !== null && color !== void 0 ? color : "currentColor" : "none",
        viewBox: viewBox,
        ...rest,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Svg);


/***/ }),

/***/ 5180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-5128de1cdb/0/cache/@emotion-react-npm-11.10.0-06b9abb1e2-6d692e43ff.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5578);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-styled-virtual-2aaf7f2de3/0/cache/@emotion-styled-npm-11.10.0-ee745c48ee-f2a3e9798f.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(102);
// EXTERNAL MODULE: ./src/components/navigation/AppBar.tsx
var AppBar = __webpack_require__(54);
;// CONCATENATED MODULE: ./src/components/route-notice/NoticeItem.tsx


const NoticeItem = (param)=>{
    let { icon , title , time  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Article, {
        children: [
            icon,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TextWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Span, {
                        children: time
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var route_notice_NoticeItem = (NoticeItem);
const Article = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("article", {
    target: "e6te4360"
})({
    padding: "20px 0",
    display: "flex",
    gap: "8px"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.body1
    };
});
const TextWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e6te4361"
})({
    display: "flex",
    flexDirection: "column",
    gap: "8px"
});
const Heading = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", {
    target: "e6te4362"
})((param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.body1
    };
});
const Span = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e6te4363"
})((param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.caption2,
        color: theme.colors.gray4
    };
});

// EXTERNAL MODULE: ./src/styles/GlobalStyles.tsx
var GlobalStyles = __webpack_require__(6614);
;// CONCATENATED MODULE: ./src/pages/notice/index.page.tsx





const Notice = ()=>{
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalStyles/* WhiteBackgroundGlobalStyles */.ib, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppBar/* default */.Z, {
                title: "알림"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_notice_NoticeItem, {
                        icon: "\uD83C\uDFA7",
                        title: "아맞다! 이어폰은 꼭 챙기셔야 해요!",
                        time: "1초 전"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_notice_NoticeItem, {
                        icon: "\uD83C\uDFA7",
                        title: "이어폰, 노트북, 충전기, 보조배터리, 시계, 안경 모두 챙기셨나요? ",
                        time: "1초 전"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_notice_NoticeItem, {
                        icon: "\uD83C\uDFA7",
                        title: "asdf",
                        time: "1초 전"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_notice_NoticeItem, {
                        icon: "\uD83C\uDFA7",
                        title: "asdf",
                        time: "1초 전"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_notice_NoticeItem, {
                        icon: "\uD83C\uDFA7",
                        title: "asdf",
                        time: "1초 전"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_notice_NoticeItem, {
                        icon: "\uD83C\uDFA7",
                        title: "asdf",
                        time: "1초 전"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_notice_NoticeItem, {
                        icon: "\uD83C\uDFA7",
                        title: "asdf",
                        time: "1초 전"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_notice_NoticeItem, {
                        icon: "\uD83C\uDFA7",
                        title: "asdf",
                        time: "1초 전"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_notice_NoticeItem, {
                        icon: "\uD83C\uDFA7",
                        title: "asdf",
                        time: "1초 전"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_notice_NoticeItem, {
                        icon: "\uD83C\uDFA7",
                        title: "asdf",
                        time: "1초 전"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_notice_NoticeItem, {
                        icon: "\uD83C\uDFA7",
                        title: "asdf",
                        time: "1초 전"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_notice_NoticeItem, {
                        icon: "\uD83C\uDFA7",
                        title: "asdf",
                        time: "1초 전"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var index_page = (Notice);
const Main = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("main", {
    target: "e1cy9c330"
})({
    paddingTop: "8px"
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(4615); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);